import React, { useState } from "react"
import moment from "moment"

import Select from "../../../components/ui/select/select"
import Datepicker from "../../../components/ui/datepicker/datepicker"
import Button from "../../../components/ui/button/button"

const PRESETS = {
	TODAY: "Today",
	YESTERDAY: "Yesterday",
	THIS_WEEK: "This week",
	THIS_MONTH: "This month",
	CUSTOM: "Custom range",
}

const MAX_DAYS = 31

// Build a {start, end} pair (millis) from a preset key
export const rangeForPreset = (preset) => {
	switch (preset) {
		case "TODAY":
			return { start: moment().startOf("day").valueOf(), end: moment().endOf("day").valueOf() }
		case "YESTERDAY":
			return {
				start: moment().subtract(1, "day").startOf("day").valueOf(),
				end: moment().subtract(1, "day").endOf("day").valueOf(),
			}
		case "THIS_WEEK":
			return { start: moment().startOf("isoWeek").valueOf(), end: moment().endOf("day").valueOf() }
		case "THIS_MONTH":
			return { start: moment().startOf("month").valueOf(), end: moment().endOf("day").valueOf() }
		default:
			return null
	}
}

// Dropdown + optional custom range pickers. Emits {preset, start, end} via onChange.
export default function DateFilter({ preset, onChange }) {
	const [customStart, setCustomStart] = useState(null)
	const [customEnd, setCustomEnd] = useState(null)
	const [error, setError] = useState("")

	const handleSelect = ({ option }) => {
		if (option === "CUSTOM") {
			onChange({ preset: "CUSTOM", start: null, end: null })
			return
		}
		const range = rangeForPreset(option)
		onChange({ preset: option, ...range })
	}

	const applyCustom = () => {
		setError("")

		if (!customStart || !customEnd) {
			setError("Please choose both a start and end date")
			return
		}

		const start = moment(customStart).startOf("day").valueOf()
		const end = moment(customEnd).endOf("day").valueOf()

		if (end < start) {
			setError("End date must be after start date")
			return
		}

		const days = moment(end).diff(moment(start), "days") + 1
		if (days > MAX_DAYS) {
			setError(`Max range is ${MAX_DAYS} days`)
			return
		}

		onChange({ preset: "CUSTOM", start, end })
	}

	return (
		<div className="date-filter">
			<Select
				options={PRESETS}
				selected={preset}
				placeholder="Date range"
				onSelect={handleSelect}
			/>

			{preset === "CUSTOM" && (
				<div className="date-filter-custom">
					<Datepicker
						placeholder="From"
						onSelect={(millis) => setCustomStart(millis)}
					/>
					<Datepicker
						placeholder="To"
						onSelect={(millis) => setCustomEnd(millis)}
					/>
					<Button
						small={true}
						label="Apply"
						onClick={applyCustom}
					/>
					{error && <small className="date-filter-error">{error}</small>}
				</div>
			)}
		</div>
	)
}
